<main [class.has-developer-console]="developerConsoleEnabled">
    @if (developerConsoleEnabled)
    {
        <app-developer-console></app-developer-console>
    }
    <router-outlet></router-outlet>

    <app-modal [isVisible]="isShowVersionModal" [isHideHeader]="true" (onClose)="dismissUpdate()">
        <div modal-body>
            <div class="version-wrapper" role="dialog" aria-modal="true" aria-labelledby="version-update-title"
                 cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
                <h2 id="version-update-title">{{ 'UPDATE-MODAL.TITLE' | translate }}</h2>
                <p class="version-description">{{ appVersion.actual }}{{ 'UPDATE-MODAL.DESCRIPTION' | translate }}</p>
                <p class="version-number">{{ appVersion.actual }} → {{ appVersion.new }}</p>
                <div class="version-action">
                    <button class="btn" type="button" (click)="updateApp()">{{ 'UPDATE-MODAL.UPDATE_ACTION' | translate }}</button>
                    <button class="btn btn-secondary" type="button" (click)="dismissUpdate()">{{ 'UPDATE-MODAL.LATER' | translate }}</button>
                </div>
            </div>
        </div>
    </app-modal>
</main>
